module.exports = mobxReactLite;